import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { MySharedService } from '../App/shared.service';

@Component({
    templateUrl: './AppViews/Upload/upload.html'
})

export class UploadComponent implements OnInit {

    userDetail: any;
    public constants: Constants;
    public showLoader = false;
    public selectedFile = null;
    public selectedFileName: string = '';
    public fileError: boolean = false;
    public fileErrorMessage: string = '';
    public successMessage: string = '';
    public errorMessage: string = '';

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    }

    ngOnInit() { }

    public onFileChange(event: any) {
        this.fileError = false;
        this.fileErrorMessage = '';
        this.successMessage = '';
        this.errorMessage = '';

        const files = event.target.files;
        if (files && files.length > 0) {
            const file: File = files[0];
            const ext = file.name.split('.').pop().toLowerCase();
            if (ext !== 'xlsx' && ext !== 'xls' && ext !== 'csv') {
                this.fileError = true;
                this.fileErrorMessage = 'Only Excel files (.xlsx, .xls) or CSV files (.csv) are allowed.';
                this.selectedFile = null;
                this.selectedFileName = '';
                return;
            }
            this.selectedFile = file;
            this.selectedFileName = file.name;
        }
    }

    public uploadFile() {
        if (!this.selectedFile) {
            this.fileError = true;
            this.fileErrorMessage = 'Please select a file to upload.';
            return;
        }

        this.showLoader = true;
        this.successMessage = '';
        this.errorMessage = '';

        const formData = new FormData();
        formData.append('file', this.selectedFile, this.selectedFile.name);

        this._httpService.ajaxPostBiometric('Upload/UploadBiometric', formData).then(
            data => {
                this.showLoader = false;
                const msg: string = data['Message'] || '';
                const parts = msg.split('|');
                const type = parts[0] ? parts[0].toLowerCase() : '';
                const text = parts[1] || msg;
                if (type === 'success') {
                    this.successMessage = text;
                    this.clearFile();
                } else {
                    this.errorMessage = text;
                }
            },
            err => {
                this.showLoader = false;
                this.errorMessage = 'Error Occurred, Please Contact Administrator.';
            }
        );
    }

    public clearFile() {
        this.selectedFile = null;
        this.selectedFileName = '';
        this.fileError = false;
        this.fileErrorMessage = '';
        const fileInput = document.getElementById('biometricFile') as HTMLInputElement;
        if (fileInput) fileInput.value = '';
    }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/Upload/upload.component.ts
 **/